import { SITE } from "@/constants/testIds";

const BG =
  "https://images.pexels.com/photos/17654134/pexels-photo-17654134.jpeg?auto=compress&cs=tinysrgb&w=2000";

export default function Inspiration() {
  return (
    <section
      data-testid={SITE.inspiration}
      className="relative isolate overflow-hidden"
    >
      <img
        src={BG}
        alt="Serene river nestled between lush green hills"
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-brand-evergreen/70" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-evergreen/40 to-brand-evergreen/80" />

      <div className="relative z-10 mx-auto max-w-5xl px-6 py-28 text-center md:py-40">
        <span className="text-xs uppercase tracking-[0.4em] text-brand-sand">
          Why I teach
        </span>
        <blockquote className="mt-8 font-display text-3xl italic leading-snug text-brand-cream sm:text-4xl md:text-5xl lg:text-6xl">
          <span className="mr-2 align-top text-5xl text-brand-sand md:text-7xl">“</span>
          Teaching people to fly cast was born from a desire to share the Spirit
          and connection I discovered on the water.
          <span className="ml-1 align-top text-5xl text-brand-sand md:text-7xl">”</span>
        </blockquote>
        <div className="mt-10 flex items-center justify-center gap-3">
          <span className="h-px w-10 bg-brand-sand/70" />
          <span className="text-sm uppercase tracking-[0.3em] text-brand-cream/80">
            Mike, founder
          </span>
          <span className="h-px w-10 bg-brand-sand/70" />
        </div>
      </div>
    </section>
  );
}
